import {PROPERTIES_SET} from '../../constants';

export function isPropertyUpdate(type) {
	return type === PROPERTIES_SET;
}
